import { Controller } from "@hotwired/stimulus"

import { Spinner } from "spin.js"
import { opts } from "../src/spinner_opts"

export default class extends Controller {
  static targets = ["country", "select"]

  disconnect() {
    this.teardown()
  }

  teardown() {
    this.stopLoading()
  }

  change(event) {
    if (event.target !== this.selectTarget && !event.target.matches("input.filter-input[type=checkbox]")) return

    if (this.countryTargets.includes(event.target)) {
      this.clearCountries(event.target)
      this.selectTarget.value = ""
      this.selectTarget.dispatchEvent(new Event("search-picker:refresh"))
    } else if (event.target === this.selectTarget) {
      this.clearCountries()
    }
    this.stopLoading()
    this.table = document.getElementById("brands-table")
    if (this.table) {
      this.spinner = new Spinner(opts).spin(this.table)
      this.table.classList.add("opacity-50")
    }
    this.element.requestSubmit()
  }

  clearCountries(selected) {
    this.countryTargets.forEach(input => { if (input !== selected) input.checked = false })
  }

  stopLoading() {
    this.spinner?.stop()
    this.spinner = null
    this.table?.classList.remove("opacity-50")
    this.table = null
  }
}
